import { getTheme } from "@ane/ui-components";
var QuickValidateStatuses = /* @__PURE__ */ ((QuickValidateStatuses2) => {
  QuickValidateStatuses2["NotStarted"] = "NotStarted";
  QuickValidateStatuses2["InProgress"] = "InProgress";
  QuickValidateStatuses2["CompiledSuccessfully"] = "CompiledSuccessfully";
  QuickValidateStatuses2["Success"] = "Success";
  QuickValidateStatuses2["Failed"] = "Failed";
  QuickValidateStatuses2["HitMaxRetryCount"] = "HitMaxRetryCount";
  QuickValidateStatuses2["NotFound"] = "NotFound";
  return QuickValidateStatuses2;
})(QuickValidateStatuses || {});
var QuickCompilationStatuses = /* @__PURE__ */ ((QuickCompilationStatuses2) => {
  QuickCompilationStatuses2["Succeeded"] = "Succeeded";
  QuickCompilationStatuses2["Failed"] = "Failed";
  QuickCompilationStatuses2["NotStarted"] = "NotStarted";
  return QuickCompilationStatuses2;
})(QuickCompilationStatuses || {});
var QuickValidateAPIStatus = /* @__PURE__ */ ((QuickValidateAPIStatus2) => {
  QuickValidateAPIStatus2["Accepted"] = "Accepted";
  QuickValidateAPIStatus2["Compiled"] = "Compiled";
  QuickValidateAPIStatus2["Submitted"] = "Submitted";
  QuickValidateAPIStatus2["Completed"] = "Completed";
  QuickValidateAPIStatus2["Failed"] = "Failed";
  return QuickValidateAPIStatus2;
})(QuickValidateAPIStatus || {});
const theme = getTheme();
const compileFailedIconProps = {
  ariaLabel: "Failed",
  iconName: "Blocked2Solid",
  style: {
    color: theme.palette.red,
    fontSize: theme.fonts.small.fontSize,
    height: theme.fonts.small.fontSize,
    lineHeight: theme.fonts.medium.fontSize
  }
};
const compileFailedLinkProps = {
  ariaLabel: "Failed",
  style: { fontSize: theme.fonts.small.fontSize, height: theme.fonts.medium.fontSize }
};
const compileSucceededIconProps = {
  ariaLabel: "Succeeded",
  iconName: "CompletedSolid",
  style: {
    color: theme.palette.green,
    fontSize: theme.fonts.small.fontSize,
    height: theme.fonts.small.fontSize,
    lineHeight: theme.fonts.medium.fontSize
  }
};
const compileSucceededTextProps = {
  style: { fontSize: theme.fonts.small.fontSize, height: theme.fonts.medium.fontSize }
};
const LoadQuickResultPollInterval = 10 * 1e3;
const LoadQuickResultMaxRetryCount = 60 * 12;
const quickCompileTitle = "Compile result";
const quickPreviewTitle = "Preview result";
const loadingQuickResultText = "Please wait while the metric is being compiled and computed.";
const loadingComputationText = "Metric successfully compiled. Awaiting computation. This could take up to 15 minutes...";
const loadQuickResultErrorPrefix = "Load quick preview result failed, error:";
const loadQuickResultExceedMaxRetryText = "Loading quick preview result hits max retry count, please wait or refresh the page.";
const putQuickErrorPrefix = "Quick preview request failed, error:";
export {
  LoadQuickResultMaxRetryCount,
  LoadQuickResultPollInterval,
  QuickCompilationStatuses,
  QuickValidateAPIStatus,
  QuickValidateStatuses,
  compileFailedIconProps,
  compileFailedLinkProps,
  compileSucceededIconProps,
  compileSucceededTextProps,
  loadQuickResultErrorPrefix,
  loadQuickResultExceedMaxRetryText,
  loadingComputationText,
  loadingQuickResultText,
  putQuickErrorPrefix,
  quickCompileTitle,
  quickPreviewTitle
};
//# sourceMappingURL=QuickValidate.constants.js.map
